import {
  UPDATE_SEARCH_KEYWORD,
  SUBMIT_SEARCH_BY_ENTER,
  SET_SEARCH_CONTEXT,
} from "../actions";

const INIT_STATE = {
  keyword: "", // Giá trị ban đầu của input
  enterPressCount: 0, // Bắt đầu từ 0
  context: "dashboard", // Context mặc định - 'dashboard' | 'product' | 'stock' | 'customer' | 'order'
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_KEYWORD:
      return { ...state, keyword: action.payload };

    case SUBMIT_SEARCH_BY_ENTER:
      // Mỗi lần nhận action này, tăng bộ đếm lên 1
      return { ...state, enterPressCount: state.enterPressCount + 1 };

    case SET_SEARCH_CONTEXT:
      // Set context và reset keyword khi chuyển trang
      return { ...state, context: action.payload, keyword: "" };

    default:
      return state;
  }
};
